import React from 'react'
import { Field, InjectedFormProps } from 'redux-form'
import Radio from 'components/Input/Radio'
import cn from 'classnames'
import s from './VpbxPlan.scss'
import sLay from 'styles/modules/layout.scss'
import sText from 'components/Text/Text.scss'
import { GetUsagePlansQuery } from 'src/generated/graphql'

export interface IVpbxPlanProps {
  change: InjectedFormProps['change']
  plan: GetUsagePlansQuery['usagePlans'][0]
}

export const VpbxPlan = (props: IVpbxPlanProps) => {
  const { plan, change } = props
  return (
    <div className={s.outer}>
      <div className={cn(s.heading, sText.heading4)}>{plan.name}</div>
      <div className={sLay['layout-row']}>
        <div className={cn(sLay.flex, s.descrip)}>
          <div>DID Numbers: {plan.maxDIDNumbers}</div>
          <div>Extensions: {plan.maxExtensions}</div>
          <div>Hunt Groups: {plan.maxHuntGroups}</div>
          <div>Simultaneous Calls: {plan.simultaneousCallsLimit}</div>
        </div>
        <div className={sText.descrip3}>${plan.monthlyCharge}/month</div>
        <Field
          className={s.radio}
          component={Radio}
          showTip
          name="productName"
          radioValue={plan.alias}
          onChange={() => {
            change('plan', plan)
          }}
        />
      </div>
    </div>
  )
}



// WEBPACK FOOTER //
// src/features/PhoneSystem/PhoneSystemForm/VpbxPlan/VpbxPlan.tsx